import { defineStyleConfig } from '@chakra-ui/react';

const Select = defineStyleConfig({
  variants: {
    outline: (props) => ({
      field: {
        bg: props.colorMode === 'dark' ? 'gray.900' : 'white',
        borderColor: props.colorMode === 'dark' ? 'gray.600' : 'gray.400',
        _hover: {
          borderColor: props.colorMode === 'dark' ? 'gray.500' : 'gray.500',
        },
        _focus: {
          borderColor: props.colorMode === 'dark' ? 'brand.orange.500' : 'brand.blue.500',
          boxShadow: props.colorMode === 'dark' ? 'focus_admin' : 'focus',
        },
      },
      icon: {
        color: props.colorMode === 'dark' ? 'text.secondary' : 'gray.500',
      },
    }),
  },
  defaultProps: {
    variant: 'outline',
  },
});

export default Select;